import { Container, Box, Alert, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { TABLE_HEAD_SWAP_REBALANCE_ITEMS } from "../../../../component/Methods";
import { useSelector } from "react-redux";

import SwapRebalanceItems from "../../Components/SwapRebalanceItems";
import SwapRebalanceFinalSkeleton from "../../Skeletons/SwapRebalanceFinalSkeleton";
import {
  selectSwapFinalStrategies,
  selectActiveRequests,
} from "../../../../Redux/Reducers/selectors";

const SwapStep3 = ({ setCurrentStep, contracts }) => {
  const swapFinalStrategies = useSelector(selectSwapFinalStrategies);
  const activeRequests = useSelector(selectActiveRequests);
  const [selectedContract, setSelectedContract] = useState("all");
  const [filteredContracts, setFilteredContracts] = useState([]);
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (swapFinalStrategies) {
      setFilteredContracts(swapFinalStrategies);
    } else {
      setFilteredContracts([]);
    }
  }, [swapFinalStrategies]);

  useEffect(() => {
    if (selectedContract === "all") {
      setFilteredContracts(swapFinalStrategies || []);
    } else {
      const filtered =
        swapFinalStrategies?.filter(
          (contract) => contract.id === selectedContract
        ) || [];
      setFilteredContracts(filtered);
    }
  }, [selectedContract, swapFinalStrategies]);

  useEffect(() => {
    const hasErrors = swapFinalStrategies?.every(
      (contract) => contract.validationErrors?.length > 0
    );
    setHasValidationErrors(hasErrors);
    const allSuccessful = swapFinalStrategies?.every(
      (contract) => contract.success === true
    );
    setShowSuccessMessage(!hasValidationErrors && allSuccessful);
  }, [swapFinalStrategies]);

  const isLoadingBlacklistedData = activeRequests.includes("rebalance_swaps");

  if (isLoadingBlacklistedData) {
    return <SwapRebalanceFinalSkeleton />;
  }

  return (
    <Container
      disableGutters
      maxWidth="100%"
      sx={{
        marginTop: 2,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          overflow: "hidden",
          gap: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            flexShrink: 0,
          }}
        >
          <Box sx={{ width: "40%" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
                Submitted Contracts
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <select
                  value={selectedContract}
                  onChange={(e) => setSelectedContract(e.target.value)}
                  style={{
                    padding: "5px",
                    fontSize: "14px",
                    marginBottom: 10,
                  }}
                  size="small"
                >
                  <option value="all">All</option>
                  {swapFinalStrategies?.map((contract) => (
                    <option key={contract.id} value={contract.id}>
                      {contract.name}
                    </option>
                  ))}
                </select>
              </Box>
            </Box>
          </Box>
        </Box>

        {showSuccessMessage && (
          <Alert severity="success" sx={{ flexShrink: 0 }}>
            Rebalance request submitted, you will be notified via email once
            its completed.
          </Alert>
        )}

        {!showSuccessMessage && filteredContracts?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "60%",
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                width: "100%",
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <SwapRebalanceItems
                filteredContracts={filteredContracts}
                tableHeader={TABLE_HEAD_SWAP_REBALANCE_ITEMS}
                hasValidationErrors={hasValidationErrors}
                filteredStrategies={false}
                fillHeight
              />
            </Box>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default SwapStep3;
